// extracted by css-extract-rspack-plugin
export default {"sidebar":"CaeIJ"};